export const norwegianGroceries = {
  templateId: 'groceries',
  language: 'no',
  name: 'Dagligvarer (Norsk)',
  description: 'Vanlige matvarer for norske butikker som Rema 1000, Coop Extra og Kiwi',
  icon: '🛒',
  categories: [
    {
      name: 'Kjøtt og fisk',
      items: [
        'Kyllingfilet',
        'Kjøttdeig',
        'Koteletter',
        'Bacon',
        'Pølser',
        'Laks',
        'Torsk',
        'Reker',
        'Kyllinglår',
        'Entrecôte',
        'Skinke',
        'Leverpostei',
        'Hamburger',
        'Karbonadedeig',
        'Ørret',
        'Kalkun',
        'And',
        'Elg',
        'Reinsdyr',
        'Lammekoteletter',
        'Svinekjøtt',
        'Oksefilet',
        'Pølse til grilling',
        'Spekeskinke',
        'Kyllingvinger',
        'Kylling hel',
        'Sei',
        'Makrell',
        'Sardiner',
        'Tunfisk',
        'Krabbe',
        'Hummer',
        'Kamskjell',
        'Blåskjell',
        'Røkelaks',
        'Gravlaks',
        'Fiskekaker',
        'Kjøttpudding',
        'Spekemat',
        'Salami',
        'Chorizo',
        'Pepperoni',
        'Medisterpølse',
        'Fårikål',
        'Kjøttboller',
        'Biff',
        'Indrefilet',
        'Flatbiff',
        'Koteletter av svin'
      ]
    },
    {
      name: 'Meieri',
      items: [
        'Melk',
        'Ost',
        'Smør',
        'Yoghurt',
        'Egg',
        'Rømme',
        'Fløte',
        'Cottage cheese',
        'Margarin',
        'Majones',
        'Kremfløte',
        'Kesam',
        'Norvegia',
        'Gouda',
        'Brie',
        'Mozzarella',
        'Hvitost',
        'Gulost',
        'Jarlsberg',
        'Ridder',
        'Nøkkelost',
        'Kamelost',
        'Cheddar',
        'Parmesan',
        'Feta',
        'Geitost',
        'Melk lettmelk',
        'Melk skummet',
        'Melk helmelk',
        'Melk økologisk',
        'Kjernemelk',
        'Yoghurt naturell',
        'Yoghurt med frukt',
        'Gresk yoghurt',
        'Drikkeyoghurt',
        'Kvarg',
        'Kulturmelk',
        'Filmjölk',
        'Eggnog',
        'Kondensert melk',
        'Melkepulver',
        'Pisket krem',
        'Seterrømme',
        'Crème fraîche',
        'Mascarpone',
        'Ricotta',
        'Eggehvite',
        'Eggeplomme',
        'Vaktel egg'
      ]
    },
    {
      name: 'Frukt og grønt',
      items: [
        'Epler',
        'Bananer',
        'Gulrøtter',
        'Løk',
        'Poteter',
        'Tomater',
        'Agurk',
        'Paprika',
        'Appelsin',
        'Sitron',
        'Salat',
        'Brokkoli',
        'Blomkål',
        'Persille',
        'Dill',
        'Sellerirot',
        'Rødløk',
        'Hvitløk',
        'Ingefær',
        'Avokado',
        'Druer',
        'Jordbær',
        'Blåbær',
        'Bringebær',
        'Kirsebær',
        'Pærer',
        'Fersken',
        'Plommer',
        'Aprikoser',
        'Kiwi',
        'Mango',
        'Ananas',
        'Klementin',
        'Grape',
        'Lime',
        'Vannmelon',
        'Honningmelon',
        'Kantarel',
        'Sopp',
        'Champignon',
        'Spinat',
        'Ruccola',
        'Feldsalat',
        'Hodekål',
        'Kålrot',
        'Purre',
        'Fennikel',
        'Selleri',
        'Kinakål',
        'Rødbeter',
        'Pastinakk',
        'Gresskar',
        'Squash',
        'Aubergine',
        'Chili',
        'Jalapeño',
        'Rosenkål',
        'Grønnkål',
        'Mais',
        'Gressløk',
        'Basilikum',
        'Timian',
        'Rosmarin',
        'Koriander',
        'Mynthe',
        'Estragon',
        'Salvie',
        'Oregano',
        'Rødkål',
        'Spitskål',
        'Reddik',
        'Knollselleri',
        'Artisokk',
        'Asparges',
        'Sorrel',
        'Cherrytomater',
        'Roma tomater',
        'Beef tomater'
      ]
    },
    {
      name: 'Brød og bakevarer',
      items: [
        'Brød',
        'Rundstykker',
        'Kavring',
        'Knekkebrød',
        'Boller',
        'Bagett',
        'Polarbrød',
        'Lefse',
        'Kneipp',
        'Grovbrød',
        'Loff',
        'Croissant',
        'Wienerbrød',
        'Kringle'
      ]
    },
    {
      name: 'Fryste varer',
      items: [
        'Frosne grønnsaker',
        'Is',
        'Pizza',
        'Fiskepinner',
        'Pommes frites',
        'Frosne bær',
        'Fiskegrateng',
        'Lasagne',
        'Frosne erter',
        'Frosne spinat',
        'Frosset kylling',
        'Pannekaker',
        'Vafler',
        'Fiskeboller',
        'Frosne brokkoli',
        'Frosne blomkål',
        'Frosne rosenkål',
        'Frosset mais',
        'Frosne gulrøtter',
        'Frosne bønner',
        'Frosne blandede grønnsaker',
        'Frosset wok-mix',
        'Frosne løk',
        'Frosne paprika',
        'Frosne reker',
        'Frosne kamskjell',
        'Frosset laks',
        'Frosset torsk',
        'Frosset kolje',
        'Frosset rødspette',
        'Frosset kjøttdeig',
        'Frosne pølser',
        'Frosset bacon',
        'Frosne kyllingfileter',
        'Frosne kyllinglår',
        'Frosne kyllingvinger',
        'Frosset kalkun',
        'Frosset lam',
        'Frosset storfe',
        'Frosne poteter',
        'Frosne potetbåter',
        'Frosne hash browns',
        'Frosne løkringer',
        'Frosne kyllingnuggets',
        'Frosne hamburgere',
        'Frosset butterdeig',
        'Frosne croissanter',
        'Frosset hvitløksbrød',
        'Frosne yorkshire puddings',
        'Frosne ispinner',
        'Frosset sorbet',
        'Frosset yoghurt',
        'Frosne smoothie-pakker',
        'Frosne jordbær',
        'Frosne bringebær',
        'Frosne bjørnebær',
        'Frosne blåbær',
        'Frosset mango',
        'Frosset ananas',
        'Frosset tropisk fruktmiks',
        'Frosset rabarbra',
        'Frosne epleskiver'
      ]
    },
    {
      name: 'Tørrvarer',
      items: [
        'Pasta',
        'Ris',
        'Mel',
        'Sukker',
        'Salt',
        'Hermetikk',
        'Müsli',
        'Havregryn',
        'Pepper',
        'Oregano',
        'Basilikum',
        'Makaroni',
        'Spaghetti',
        'Tomatboks',
        'Bønner',
        'Mais',
        'Olje',
        'Eddik',
        'Sennep',
        'Quinoa',
        'Bulgur',
        'Couscous',
        'Linser',
        'Kikkerter',
        'Hirse',
        'Byggrygg',
        'Basmati ris',
        'Jasmin ris',
        'Vill ris',
        'Risnudler',
        'Soba nudler',
        'Udon nudler',
        'Lasagne plater',
        'Penne',
        'Fusilli',
        'Farfalle',
        'Tagliatelle',
        'Linguine',
        'Ravioli',
        'Gnocchi',
        'Polenta',
        'Sesamfrø',
        'Solsikkefrø',
        'Gresskarfrø',
        'Linfrø',
        'Chiafrø',
        'Mandler',
        'Valnøtter',
        'Hasselnøtter',
        'Pistasj',
        'Pekannøtter',
        'Cashewnøtter',
        'Paranøtter',
        'Macadamianøtter',
        'Rosiner',
        'Dadler',
        'Fiken',
        'Aprikoser tørket',
        'Kranbær tørket',
        'Olivenolje',
        'Rapsolje',
        'Solsikkeolje',
        'Kokosolje',
        'Sesamolje',
        'Balsamico',
        'Hvitløkseddik',
        'Eplecidereddik',
        'Honning',
        'Ahornsirup',
        'Agavesirup',
        'Vaniljesukker',
        'Kanel',
        'Kardemomme',
        'Muskatnøtt',
        'Ingefær tørket',
        'Paprika krydder',
        'Kumin',
        'Koriander frø',
        'Curry',
        'Garam masala',
        'Tandoori',
        'Cayennepepper',
        'Smørepaprika',
        'Røkt paprika',
        'Laurbærblad',
        'Nellik',
        'Stjerneanis',
        'Hvitløkspulver',
        'Løkpulver',
        'Jordbærsyltetøy',
        'Bringebærsyltetøy',
        'Blåbærsyltetøy',
        'Aprikos syltetøy',
        'Appelsin marmelade',
        'Multesyltetøy',
        'Hjemmelaget syltetøy',
        'Solbærsyltetøy',
        'Svisker syltetøy',
        'Nugatti',
        'Nutella'
      ]
    },
    {
      name: 'Drikke',
      items: [
        'Kaffe', 'Te', 'Juice', 'Brus', 'Pepsi Max', 'Pepsi', 'Coca-Cola', 'Coca-Cola Zero', 'Solo', 'Fanta', 'Sprite', 'Urge', 'Mountain Dew', 'Red Bull', 'Battery', 'Villa', 'Tonic', 'Ingefærøl', 'Limonade',
        'Øl', 'Pils', 'IPA', 'Pale Ale', 'Lager', 'Stout', 'Porter', 'Hveteøl', 'Cider', 'Radler', 'Alkoholfritt øl',
        'Vin', 'Rødvin', 'Hvitvin', 'Rosévin', 'Champagne', 'Cava',
        'Mineralvann', 'Appelsinjuice', 'Eplejuice', 'Kakao', 'Energidrikk', 'Saft', 'Melk (drikke)', 'Lettøl', 'Vann', 'Sprudlevann', 'Tranebærjuice', 'Druesaft', 'Ananasjuice', 'Tomatjuice',
        'Grønn te', 'Sort te', 'Earl Grey', 'Urtete', 'Kamillele', 'Peppermyntete', 'Instant kaffe', 'Kaffebønner', 'Malt kaffe', 'Koffeinfri kaffe', 'Espresso',
        'Sodavann', 'Kokosvann', 'Sportsdrikk', 'Smoothies', 'Proteinshakes',
        'Brennevin', 'Whisky', 'Vodka', 'Gin', 'Rom', 'Konjakk', 'Likør'
      ]
    },
    {
      name: 'Snacks og søtsaker',
      items: [
        'Sjokolade',
        'Kjeks',
        'Potetgull',
        'Nøtter',
        'Godteri',
        'Cookies',
        'Popcorn',
        'Pepperkaker',
        'Granola barer',
        'Fruktsnacks',
        'Vafler',
        'Iskrem',
        'Gelé',
        'Tyggegummi',
        'Drops',
        'Kake',
        'Donuts',
        'Småkaker',
        'Trail mix',
        'Protein barer',
        'Riskaker',
        'Kornmo',
        'Saltpinne',
        'Nachos',
        'Sursøte',
        'Lakrits',
        'Toffee',
        'Karamell',
        'Marzipan',
        'Nougat',
        'Marshmallow',
        'Gelebjørn',
        'Vingummi',
        'Sjokoladeplate',
        'Snickers',
        'Kit Kat',
        'Twix',
        'Bounty',
        'Mars',
        'Daim',
        'Toblerone',
        'Freia melkesjokolade',
        'Kvikk Lunsj',
        'Stratos'
      ]
    },
    {
      name: 'Rengjøring og hygiene',
      items: [
        'Oppvaskmiddel',
        'Tøymykner',
        'Toalettpapir',
        'Såpe',
        'Shampoo',
        'Tannkrem',
        'Tannbørste',
        'Vaskepulver',
        'Allrent',
        'Kjøkkenpapir',
        'Deodorant',
        'Barberskum',
        'Bleie',
        'Damehygiene',
        'Kondom',
        'Vasketabletter',
        'Tøykonsentrat',
        'Flekkfjerning',
        'Klorin',
        'Desinfeksjon',
        'Vinduspuss',
        'Badrens',
        'Toalettrens',
        'Gulvrens',
        'Møbelpolitur',
        'Ovnsrens',
        'Vaskemaskinrens',
        'Oppvasktabletter',
        'Skyllemiddel',
        'Salt (oppvaskmaskin)',
        'Svamper',
        'Rengjøringskluter',
        'Gummihansker',
        'Søppelposer',
        'Plastfolie',
        'Aluminiumsfolie',
        'Bakepapir',
        'Lommetørkle',
        'Våtservietter',
        'Babyvåtservietter',
        'Håndsåpe',
        'Håndsprit',
        'Dusjakrem',
        'Balsam',
        'Hårgele',
        'Hårspray',
        'Hudkrem',
        'Solkrem',
        'Aftershave',
        'Parfyme',
        'Cologne',
        'Munnvann',
        'Tanntråd',
        'Barberbad',
        'Barberskum',
        'Tampong',
        'Bind',
        'Truseinnlegg',
        'Graviditetstest',
        'Vitaminer',
        'Paracet',
        'Ibux',
        'Aspirin',
        'Plaster',
        'Antiseptisk krem',
        'Øyedråper',
        'Kontaktlinservæske'
      ]
    }
  ]
};
